import PessoaIdosaIcon from '@/components/icons/IndicadoresAps/eSFeAP/PessoaIdosa.vue'

export default {
  value: 'c6',
  label: 'Pessoa idosa',
  iconType: 'component',
  iconComponent: PessoaIdosaIcon,
  buscaAtiva: {
    a: ({ perfilOdontoOuEmulti }) =>
      perfilOdontoOuEmulti
        ? 'Encaminhar para realizar e registrar a consulta da pessoa idosa (em atraso).'
        : 'Realizar e registrar a consulta da pessoa idosa (em atraso).',
    b: ({ perfilOdontoOuEmulti }) =>
      perfilOdontoOuEmulti
        ? 'Encaminhar para aferir e registrar peso e altura (em atraso).'
        : 'Aferir e registrar peso e altura (em atraso).',
    c: 'Acionar o Agente de Saúde para visita domiciliar (em atraso).',
    d: 'Encaminhar para a vacina influenza (em atraso).',
  },
}
